import React, { useState } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import CategoryTabs from '../components/CategoryTabs';
import PostList from '../components/PostList';
import CommunitySearch from '../components/CommunitySearch';
import { CATEGORIES, categoryLabel } from '../api/community';
import { useAuth } from '../contexts/AuthContext';

const VALID_IDS = CATEGORIES.map(c => c.id);

export default function CommunityPage() {
  const { category } = useParams();
  const [, setSearchActive] = useState(false);
  const { isAdmin } = useAuth();

  // /community/ → redirect to default category (review)
  if (!category) return <Navigate to="/community/review" replace />;

  // Unknown category → redirect to review
  if (!VALID_IDS.includes(category)) return <Navigate to="/community/review" replace />;

  // Notice category is admin-only for writing — redirect non-admin to review on the write button.
  const writeCategory = (category === 'notice' && !isAdmin) ? 'review' : category;
  const canWriteHere = !(category === 'notice' && !isAdmin);

  return (
    <div className="container" style={{ paddingTop: 100, paddingBottom: 60 }}>
      <title>{categoryLabel(category)} - 커뮤니티 | KOA DETAILING</title>
      <meta name="description" content={`KOA DETAILING 커뮤니티 ${categoryLabel(category)} 게시판 — 후기, 질문, 자유 게시글을 확인하세요.`} />

      <div className="page-header" style={{ marginBottom: 24, paddingTop: 0 }}>
        <span className="badge badge-primary" style={{ marginBottom: 12 }}>COMMUNITY</span>
        <h1 style={{ marginBottom: 8 }}>커뮤니티</h1>
        <p style={{ color: 'var(--text-muted)' }}>
          KOA DETAILING 회원들의 후기·질문·소식을 모아보는 공간
        </p>
      </div>

      {/* Category tabs with the 글쓰기 button at the right end, above the search box */}
      <div style={{
        display: 'flex', alignItems: 'flex-end',
        gap: 12, flexWrap: 'wrap',
      }}>
        <div style={{ flex: '1 1 280px', minWidth: 0 }}>
          <CategoryTabs activeId={category} />
        </div>
        {canWriteHere && (
          <Link
            to={`/community/write?category=${writeCategory}`}
            className="btn btn-primary"
            style={{
              padding: '10px 18px', fontSize: '0.9rem',
              textDecoration: 'none', whiteSpace: 'nowrap',
              marginLeft: 'auto', marginBottom: 24,
            }}
          >
            ✏️ 글쓰기
          </Link>
        )}
      </div>

      <CommunitySearch
        category={category}
        onClear={() => setSearchActive(false)}
      />

      <PostList category={category} key={category} />
    </div>
  );
}
